import { normalizeDeadline } from "../deadlines/normalizer";
import { normalizeDocument } from "../document/normalizers";
import { normalizeMeeting } from "../meetings/normalizers";
/*
This response is once normalized with referenceListToReferenceDataPerType.

response : {
  document: []: documentEl,
  meeting: []: meetingEl,
  deadline: []: deadlineEl,
}

*El: {
  data: {}
}
*/
// A forbidden placeholder is produced by safeReferenceRequest when the entity
// returned 401 from the proxy. We keep it in the list as a stub with just
// { forbidden: true, uri } so the UI can render a blank box for it.
const toForbiddenStub = (el) => ({ forbidden: true, uri: el?.data?.uri });

export function normalizeObjectOfReferences(responses) {
  // need to find out if references[0] type is worth using.
  const document =
    responses.document
      ?.filter((d) => !!d)
      .map((documentEl) =>
        documentEl.forbidden
          ? toForbiddenStub(documentEl)
          : normalizeDocument(documentEl.data),
      ) ?? [];

  const meeting =
    responses.meeting
      ?.filter((d) => !!d)
      .map((meetingEl) =>
        meetingEl.forbidden
          ? toForbiddenStub(meetingEl)
          : normalizeMeeting(meetingEl.data),
      ) ?? [];

  const deadline =
    responses.deadline
      ?.filter((d) => !!d)
      .map((deadlineEl) =>
        deadlineEl.forbidden
          ? toForbiddenStub(deadlineEl)
          : normalizeDeadline({ deadline: deadlineEl.data }),
      ) ?? [];

  return {
    document,
    meeting,
    deadline,
  };
}
